import Cookies from 'cookies';
import { GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import GuideToBuyingEvContainer from '~/components/ev/guide-to-buying-ev/GuideToBuyingEvContainer';
import {
  guideToBuyingEvProject,
  guideToBuyingEvTrack
} from '~/constants/eventable';
import EvProviders, { EvProvidersProps } from '~/context/ev/EvProviders';
import { GuideToEvStaticConfigs } from '~/server-props/ev/constants';
import getProps from '~/server-props/ev/getProps';
import getRequestContext from '~/server-props/ev/guide-to-buying-ev/getRequestContext';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

type OwnProps = {
  forProviders: EvProvidersProps;
};

export default function GuideToBuyingEv(props: OwnProps) {
  return (
    <div>
      <NextSeo
        title="Your Guide to Buying a Used EV | Carvana"
        description="What to know about range, battery, vehicle history, and charging-- A comprehensive guide to purchasing a pre-owned electric vehicle."
      />
      <ErrorBoundary>
        <EvProviders
          eventableProject={guideToBuyingEvProject}
          eventableTrack={guideToBuyingEvTrack}
          {...props.forProviders}
        >
          <GuideToBuyingEvContainer />
        </EvProviders>
      </ErrorBoundary>
    </div>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const requestContext = await getRequestContext(context.req);
  const serverCookies = new Cookies(context.req, context.res, { secure: true });

  return getProps(
    context,
    requestContext,
    serverCookies,
    GuideToEvStaticConfigs
  );
}
